import { LoadingDots } from '@flos/react-ui';
import axios from 'axios';
import track, { errorTypes } from 'c9-tracking';
import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FALLBACK_URL } from '../constants';
import { navigationActions } from '../store/navigation.slice';
import { IState } from '../types';

const Preloading = ({ children }: { children: React.ReactNode }) => {
  const [loaded, setLoaded] = useState(false);

  const host = useSelector<IState, string>((state) => state.settings.endpointConfig.apiAwsBase);

  useValidation(host, useDispatch(), setLoaded);

  return loaded ? (
    <>{children}</>
  ) : (
    <div style={{ height: 400 }}>
      <LoadingDots />
    </div>
  );
};

const redirectToContactPage = (error: string) => {
  track.fault(error, errorTypes.user);
  window.location.replace(FALLBACK_URL);
};

const validateURL = () => {
  const hashIdentifier = window.location.hash.substr(1);
  if (document.referrer === '') {
    throw new Error('Empty referrer');
  }

  if (hashIdentifier?.trim() === '') {
    throw new Error('Empty topic');
  } else {
    return hashIdentifier;
  }
};

const isLabelValid = async (host: string, appName: string, label: string) => {
  try {
    await axios.get(`${host}/ninjas-write-to-us-api-v2/v1/validation/${label}`, {
      method: 'GET',
      headers: {
        'x-top-appname': appName,
      },
    });
    return true;
  } catch (e) {
    return false;
  }
};

const useValidation = (
  host: string,
  dispatch: Dispatch<any>,
  setLoaded: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const appName = useSelector<IState, string>((state) => state.settings.appName);

  useEffect(() => {
    // validate if referrer is not empty and URL has a topic
    let label: string;
    try {
      label = validateURL();
    } catch (e) {
      const error = e as any;
      redirectToContactPage(error.message); // For viewing the form in localhost, comment out  this line and uncomment the next
      // setLoaded(true);
      return; // halt the process as the previous statement would've redirected the user
    }

    // Make sure the given topic is valid
    (async () => {
      if (await isLabelValid(host, appName, label)) {
        dispatch(navigationActions.setTopic(label));
        setLoaded(true);
      } else {
        redirectToContactPage(`Invalid label '${label}'`);
      }
    })();
  });
};

export default Preloading;
